import { render } from "./App.vue?vue&type=template&id=5fb6dca1"
const script = {}

import "./App.vue?vue&type=style&index=0&id=5fb6dca1&lang=stylus"

import exportComponent from "/www/wwwroot/home/admin-tmp/node_modules/.store/vue-loader@16.8.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__